import {animate, group, query, state, style, transition, trigger} from '@angular/animations';

export const minify =
  trigger('minify', [
    state('true', style({ width: '80px' })),
    state('false', style({ width: '260px' })),
    transition('false => true', [
      query('@leave', animate('175ms ease-in', style({ transform: 'translateX(-250px)', opacity: 0.1 }))),
      animate('175ms ease-in', style({ width: '80px' })),
    ]),
    transition('true => false', [group([
      animate('175ms ease-in', style({ width: '260px' })),
      query('@leave', [
        style({ transform: 'translateX(-250px)', opacity: 0 }),
        animate('175ms 175ms ease-in', style({ transform: 'translateX(0)', opacity: 1 }))])
    ])
    ]),
  ]);
export const leave = trigger('leave', [
  state('in', style({ transform: 'translateX(0)', opacity: 1 })),
  state('out', style({ transform: 'translateX(-250px)', opacity: 0.1 })),
]);

export const panel = trigger('panel', [
  state('l', style({
    marginLeft: '80px'
  })),
  state('s', style({
    marginLeft: '260px'
  })),
  transition('s => l', [
    style({ marginLeft: '80px', transform: 'scaleX({{scale}}) translateX({{move}}px)' }),
    animate('175ms 300ms cubic-bezier(0.25, -0.32, 0.6, 1.04)', style({ transform: 'scaleX(1) translateX(0)' }))
  ]),
  transition('l => s', [
    style({ marginLeft: '260px', transform: 'scaleX({{scale}}) translateX(-90px)' }),
    animate('175ms cubic-bezier(0.25, -0.32, 0.6, 1.04)', style({ transform: 'scaleX(1) translateX(0)' }))
  ]),
]);

export const panelV2 = trigger('panelV2', [
  transition('s => l', [
    style({ transform: 'scaleX({{scale}}) translateX({{move}}px)' }),
    animate('175ms 300ms cubic-bezier(0.25, -0.32, 0.6, 1.04)', style({ transform: 'scaleX(1) translateX(0)' }))
  ]),
  transition('l => s', [
    style({ transform: 'scaleX({{scale}}) translateX(-90px)' }),
    animate('175ms cubic-bezier(0.25, -0.32, 0.6, 1.04)', style({ transform: 'scaleX(1) translateX(0)' }))
  ]),
]);
